// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9f6e222","457":"211a3d80","683":"b903dcbd","851":"53b8edc1"}[chunkId] + ".chunk.js";
};